import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DeclarationForm, IReadDocs } from '@models/SIO/Declaration.model';
export interface LoadingState {
  declaration: DeclarationForm | null;
  readDocs: IReadDocs | null;
  isCompleted: boolean;
  pdfPath: string;
}

const initialState: LoadingState = {
  declaration: null,
  readDocs: null,
  isCompleted: false,
  pdfPath: '',
}

const step4Slice = createSlice({
  name: 'MLTC-Step4',
  initialState,
  reducers: {
    updateDeclaration: (state, action: PayloadAction<DeclarationForm | null>) => {
      state.declaration = action.payload;
    },
    updateReadDocs: (state, action: PayloadAction<IReadDocs | null>) => {
      state.readDocs = action.payload;
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updatePdfPath: (state, action: PayloadAction<string>) => {
      state.pdfPath = action.payload;
    },
  },
  extraReducers: {}
})

export const { updateDeclaration, updateReadDocs, updatePdfPath, completeStep } = step4Slice.actions;

export default step4Slice.reducer;